import { ActionType } from '../../actionTypes';
import { createApiRequestAction } from '../../helpers';
import { users } from '../../schema';

export const fetchAllUsers = (email: string) => {
  const isValidEmail = email.trim().length === 0 ? undefined : email;
  return createApiRequestAction(ActionType.FETCH_USER_LIST_REQUESTED, {
    request: {
      method: 'GET',
      url: `/v1/concedo/search/user/${isValidEmail}/`,
      normalizr: {
        key: 'users',
        schema: [users],
      },
      responseTypes: {
        started: ActionType.FETCH_USER_LIST_STARTED,
        succeeded: ActionType.FETCH_USER_LIST_SUCCEEDED,
        failed: ActionType.FETCH_USER_LIST_FAILED,
      },
    },
  });
};
